import { ref, watch, onUnmounted, type Ref } from 'vue'
import { dateUtils } from '../utils/DateUtils'
import { useSalesReportsStore } from '../stores/salesReports'

export function useCenterTime(centerId: Ref<number | null>) {
  const centerLocalTime = ref('')
  const shouldShowTime = ref(false)
  let timeInterval: ReturnType<typeof setInterval> | null = null

  const salesReportsStore = useSalesReportsStore()

  const updateCenterTime = async () => {
    if (!centerId.value) return

    const hasDailyReports = salesReportsStore.salesReports?.some(sr => sr.type === 'daily') || false
    const shouldShow = hasDailyReports && await dateUtils.hasMultipleTimezones()

    shouldShowTime.value = shouldShow

    if (shouldShow) {
      const time = await dateUtils.getCenterLocalTime(centerId.value)
      centerLocalTime.value = time || ''
    }
  }

  watch(centerId, () => {
    updateCenterTime()
  }, { immediate: true })

  // Update time every minute
  timeInterval = setInterval(updateCenterTime, 60000)

  onUnmounted(() => {
    if (timeInterval) {
      clearInterval(timeInterval)
    }
  })

  return {
    centerLocalTime,
    shouldShowTime,
    updateCenterTime
  }
}
